module.exports = __webpack_public_path__ + "img/bg_function03_1_t.488927b3.png";